import './individual-leasings.scss';

import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import SearchInput from '@/components/Shared/Input/SearchInput';
import { SystemNotifications } from '@/components/Shared/entities';
import { ROUTES } from '@/components/Shared/routes/routes';
import { Select, Table } from '@/components/Shared/ui';
import { useAppDispatch, useAppSelector } from '@/store';
import { setHeaderConfig } from '@/store/app.slice';

import { useFetchLeasingRequests } from '../hooks';
import type { TLeasingOrder } from '../types';
import { MobileCard, tableColumns } from './entities';
import { LeasingHeader } from './ui';

const IndividualLeasings = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { userInfo } = useAppSelector((state) => state.userInfo);

  const {
    handlePageChange,
    handleUserChange,
    isLoading,
    paginationParams,
    requests,
    selectedUser,
    total
  } = useFetchLeasingRequests({ requestType: 'individual' });

  const userSelectOptions = [
    { value: userInfo?.uuid || '', label: 'Мои заявки' },
    { value: 'all', label: 'Все заявки' }
  ];

  const handleRowClick = async (r: TLeasingOrder) => {
    if (!r.autocreditRequestId || r.requestTypeCode !== 'individual') return;
    navigate(ROUTES.autoCreditRequest(r.autocreditRequestId));
  };

  useEffect(() => {
    dispatch(
      setHeaderConfig({
        title: 'Лизинг',
        helmetTitle: 'Лизинг - Физ. лица'
      })
    );
    return () => {
      dispatch(setHeaderConfig({}));
    };
  }, []);

  return (
    <>
      <SystemNotifications />

      <div className="individual-leasings">
        <LeasingHeader />
        <div className="table_editor">
          <div className="table_editor__input">
            <SearchInput placeholder="Поиск по Наименование / БИН" />
          </div>
          <div className="table_editor__select">
            <Select
              placeholder="Все заявки"
              selectedValue={userSelectOptions.find(
                (item) => item.value === selectedUser
              )}
              onChange={({ value }) => handleUserChange(value)}
              options={userSelectOptions}
            />
          </div>
        </div>
        <div className="table_editor__items">
          <Table
            columns={tableColumns}
            dataSource={requests}
            loading={isLoading}
            rowKey={(record) => record?.uuid || ''}
            pagination={{
              total,
              pageSize: paginationParams.limit,
              current: paginationParams.page,
              onChange: handlePageChange
            }}
            onRowClick={handleRowClick}
          />
        </div>
        <div className="table_editor__mobile-data">
          <MobileCard
            data={requests}
            pagination={{
              current: paginationParams.page,
              pageSize: paginationParams.limit,
              total
            }}
            onPageChange={handlePageChange}
            onClick={handleRowClick}
          />
        </div>
      </div>
    </>
  );
};

export default IndividualLeasings;
